import React from 'react';
import { css } from '@emotion/react';
import AudioStreamPreview from 'recording/components/audio-stream-preview';
import NvIcon from 'shared/components/nv-icon';
import { highTide } from 'styles/global_defaults/colors';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';

type Props = {
  mediaStream?: MediaStream;
};

const SPEAKING_BUBBLE_WIDTH = 80;
const SPEAKING_BUBBLE_HEIGHT = 40;

const styles = css`
  top: ${halfSpacing}px;
  right: ${halfSpacing}px;
  width: ${SPEAKING_BUBBLE_WIDTH}px;
  height: ${SPEAKING_BUBBLE_HEIGHT}px;
  border-radius: ${SPEAKING_BUBBLE_HEIGHT / 2}px;
  gap: ${quarterSpacing}px;
  overflow: hidden;
  .bubble-icon {
    color: ${highTide};
  }
  .audio-stream-preview {
    transform: scaleX(-1);
  }

`;
const AudioVisualizationBubble = ({ mediaStream }: Props) => (
  <div
    css={styles}
    className='px-2 bg-white position-absolute d-flex align-items-center'
  >
    <NvIcon
      className='w-25 bubble-icon d-flex justify-content-center'
      icon='audio-recording'
      size='xss-smallest'
    />
    {mediaStream && (
      <AudioStreamPreview
        mediaStream={mediaStream}
        isPlaying
        color={highTide}
        width={40}
        height={SPEAKING_BUBBLE_HEIGHT}
      />
    )}
  </div>
);

export default AudioVisualizationBubble;
